import { BlockStatusEnum, ClassCodeFlightEnum } from '@msc-b2c/interfaces/enums';
import { AirfareResponseSearch } from '@msc-b2c/interfaces/types';

export const getAirfaresResponse: AirfareResponseSearch = {
  airfares: [
    {
      price: {
        type: 'Contract',
        rules: 'Air Booking Expires on 2024-07-29',
        classCode: ClassCodeFlightEnum.ECONOMY,
        adultPrice: '806.2',
        childPrice: '0',
        infantPrice: '0',
        total: '400',
        totalTax: '0',
        adultBasisCode: '0.00',
      },
      outbound: {
        packageCode: '538305920',
        classCode: ClassCodeFlightEnum.ECONOMY,
        flightGroup: '38655340',
        segments: [
          {
            airline: {
              code: 'BA',
              name: 'British Airways',
              description: 'British Airways',
            },
            arrivalDate: '2024-08-16T19:15:00.000Z',
            arrivalTime: '17:00:00',
            blockStatus: BlockStatusEnum.OTHER,
            bookingType: 'B|RU|',
            cabinClassDescription: '',
            departureDate: '2024-08-09',
            departureTime: '13:35:00',
            fareClassCode: 'O',
            id: '1',
            legNumber: '1',
            number: '494',
            segmentNumber: '1',
            origin: {
              airport: {
                code: 'LHR',
                name: 'London - Heathrow',
                description: 'London - Heathrow',
              },
            },
            blockType: '',
            stops: '',
            destination: {
              airport: {
                code: 'PMI',
                name: 'Palma De Mallorca',
              },
            },
            totalSeatsAvailable: 10,
          },
        ],
      },
      return: {
        packageCode: '538305920',
        classCode: ClassCodeFlightEnum.ECONOMY,
        flightGroup: '38655340',
        segments: [
          {
            airline: {
              code: 'BA',
              name: 'British Airways',
              description: 'British Airways',
            },
            arrivalDate: '2024-08-16T19:15:00.000Z',
            arrivalTime: '19:15:00',
            blockStatus: BlockStatusEnum.OTHER,
            bookingType: 'B|RU|',
            cabinClassDescription: '',
            departureDate: '2024-08-16',
            departureTime: '17:45:00',
            fareClassCode: 'N',
            id: '3',
            legNumber: '2',
            number: '495',
            segmentNumber: '1',
            origin: {
              airport: {
                code: 'PMI',
                name: 'Palma De Mallorca',
                description: 'Palma De Mallorca',
              },
            },
            blockType: '',
            stops: '',
            destination: {
              airport: {
                code: 'LHR',
                name: 'London - Heathrow',
              },
            },
            totalSeatsAvailable: 9,
          },
        ],
      },
    },
    // Add the duplicate with BUSINESS_CLASS and increased price
    {
      price: {
        type: 'Contract',
        rules: 'Air Booking Expires on 2024-07-29',
        classCode: ClassCodeFlightEnum.BUSINESS_CLASS,
        adultPrice: '1106.2', // Increased by $300
        childPrice: '0',
        infantPrice: '0',
        total: '700', // Increased by $300
        totalTax: '0',
        adultBasisCode: '0.00',
      },
      outbound: {
        packageCode: '538305920',
        classCode: ClassCodeFlightEnum.BUSINESS_CLASS,
        flightGroup: '38655340',
        segments: [
          {
            airline: {
              code: 'BA',
              name: 'British Airways',
              description: 'British Airways',
            },
            arrivalDate: '2024-08-16T19:15:00.000Z',
            arrivalTime: '17:00:00',
            blockStatus: BlockStatusEnum.OTHER,
            bookingType: 'B|RU|',
            cabinClassDescription: '',
            departureDate: '2024-08-09',
            departureTime: '13:35:00',
            fareClassCode: 'O',
            id: '1',
            legNumber: '1',
            number: '494',
            segmentNumber: '1',
            origin: {
              airport: {
                code: 'LHR',
                name: 'London - Heathrow',
                description: 'London - Heathrow',
              },
            },
            blockType: '',
            stops: '',
            destination: {
              airport: {
                code: 'PMI',
                name: 'Palma De Mallorca',
              },
            },
            totalSeatsAvailable: 10,
          },
        ],
      },
      return: {
        packageCode: '538305920',
        classCode: ClassCodeFlightEnum.BUSINESS_CLASS,
        flightGroup: '38655340',
        segments: [
          {
            airline: {
              code: 'BA',
              name: 'British Airways',
              description: 'British Airways',
            },
            arrivalDate: '2024-08-16T19:15:00.000Z',
            arrivalTime: '19:15:00',
            blockStatus: BlockStatusEnum.OTHER,
            bookingType: 'B|RU|',
            cabinClassDescription: '',
            departureDate: '2024-08-16',
            departureTime: '17:45:00',
            fareClassCode: 'N',
            id: '3',
            legNumber: '2',
            number: '495',
            segmentNumber: '1',
            origin: {
              airport: {
                code: 'PMI',
                name: 'Palma De Mallorca',
                description: 'Palma De Mallorca',
              },
            },
            blockType: '',
            stops: '',
            destination: {
              airport: {
                code: 'LHR',
                name: 'London - Heathrow',
              },
            },
            totalSeatsAvailable: 9,
          },
        ],
      },
    },
    // Repeat the above pattern for the remaining airfares with BUSINESS_CLASS and updated prices
  ],
};
